import BaseModel from '../core/BaseModel'
export default class SalaryPricelistProvinceModel extends BaseModel {

    constructor() {
        super({ 
                name: "salary_pricelist_province",
                tableName: 'salary_pricelist_province', 
                label: "Bảng giá tính lương tỉnh (VPLK)", 
                display_key: 'name', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true,  
                display: false
            },
            office_vplk_ref: { 
                refs: 'office_vplk {id code name}',
                display: false
            },
            display_office_vplk: {
                name: 'display_office_vplk', 
                label: 'Mã văn phòng liên kết',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_vplk = '';
                    if(data.office_vplk !== undefined && data.office_vplk !== null){
                        data.display_office_vplk = data.office_vplk.code;
                    }
                }
            },
            display_office_vplk_name: {
                name: 'display_office_vplk_name', 
                label: 'Tên văn phòng liên kết',
                width :15, 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_vplk_name = '';
                    if(data.office_vplk !== undefined && data.office_vplk !== null){
                        data.display_office_vplk_name = data.office_vplk.name;
                    }
                }
            },
            state_ref: { 
                refs: 'state {id name}',
                display: false
            },
            display_state: {
                name: 'display_state', 
                label: 'Tỉnh / Thành phố',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_state = '';
                    if(data.state !== undefined && data.state !== null){
                        data.display_state = data.state.name;
                    }
                }
            },
            price: {
                name: 'price', 
                type: "Currency",
                label: 'Giá',
                width :8,
                class: "center",
            },
            office_tpl_ref: { 
                refs: 'office_tpl {id code}',
                display: false
            },
            display_office_tpl: {
                name: 'display_office_tpl', 
                label: 'Mã văn phòng thừa phát lại',
                width :10,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_tpl = '';
                    if(data.office_tpl !== undefined && data.office_tpl !== null){
                        data.display_office_tpl = data.office_tpl.code;
                    }
                }
            },
        },)
    }

}